import styled from 'styled-components';

import { ButtonLink } from '@common/components/Button';

export const StyledButtonLink = styled(ButtonLink)`
  margin-right: 2rem;
  margin-bottom: 2rem;

  &:last-child {
    margin-right: 0;
  }
`;

export const ButtonsWrapper = styled.div`
  a::after {
    content: none !important;
  }
`;
